import { createContext, ReactNode, useContext, useState } from "react";
import { DoingPlayerContextProps, CurrentMoveState } from "../types/context";

const DoingPlayerContext = createContext<DoingPlayerContextProps | undefined>(
  undefined
);

const initialMoveState: CurrentMoveState = {
  moveData: null,
  moveType: null,
  totalSets: null,
  duration: null,
  setRest: null,
  moveRest: null,
  superset: null,
};

function DoingPlayerProvider({ children }: { children: ReactNode }) {
  const [selectedMusic, setSelectedMusic] = useState<string | null>(null);
  const [currentMoveIndex, setCurrentMoveIndex] = useState<number>(0);
  const [playing, setPlaying] = useState<boolean>(true);
  const [isMute, setIsMute] = useState<boolean>(false);
  const [moveDuration, setMoveDuration] = useState<number | null | undefined>(
    null
  );
  const [setCounter, setSetCounter] = useState<number>(1);
  const [restOverlayVisible, setRestOverlayVisible] = useState<boolean>(false);
  const [restCountdown, setRestCountdown] = useState<number>(0);
  const [pauseMode, setPauseMode] = useState<boolean>(false);
  const [setProgress, setSetProgress] = useState<number>(0);
  const [currentMoveState, setCurrentMoveState] =
    useState<CurrentMoveState>(initialMoveState);
  const [doneTraining, setDoneTraining] = useState<boolean>(false);

  function resetSettingsPlayer() {
    setCurrentMoveIndex(0);
    setPlaying(true);
    setIsMute(false);
    setMoveDuration(null);
    setSetCounter(1);
    setRestOverlayVisible(false);
    setRestCountdown(0);
    setPauseMode(false);
    setSetProgress(0);
    setCurrentMoveState(initialMoveState);
    setDoneTraining(false);
  }

  //HANDLING PAUSE
  function handlePause() {
    if (restCountdown) return;
    setPlaying((prev) => !prev);
    setIsMute((prev) => !prev);
    setRestOverlayVisible((prev) => !prev);
    setPauseMode((prev) => !prev);
  }

  return (
    <DoingPlayerContext.Provider
      value={{
        playing,
        setPlaying,
        selectedMusic,
        setSelectedMusic,
        isMute,
        setIsMute,
        resetSettingsPlayer,
        pauseMode,
        setPauseMode,
        setProgress,
        setSetProgress,
        setCounter,
        setSetCounter,
        restOverlayVisible,
        setRestOverlayVisible,
        restCountdown,
        setRestCountdown,
        currentMoveIndex,
        setCurrentMoveIndex,
        moveDuration,
        setMoveDuration,
        currentMoveState,
        setCurrentMoveState,
        handlePause,
        doneTraining,
        setDoneTraining,
      }}
    >
      {children}
    </DoingPlayerContext.Provider>
  );
}

function useDoingPlayerContext() {
  const context = useContext(DoingPlayerContext);
  if (context === undefined)
    throw new Error(
      "DoingPlayerContext was used outside of DoingPlayerProvider"
    );
  return context;
}

export { DoingPlayerProvider, useDoingPlayerContext };
